import React from 'react';
import { AuthRoles } from "components/auth";

export const LoansConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/loans`,
      component: React.lazy(() => import('./Loans'))
    }
  ]
};